export const AssessmentType = Object.freeze({
  InitialAssessment: 'Initial assessment',
  ReAssessment: 'Re-assessment',
  Unalignment: 'Unalignment',
  AnnualAssessment: 'Annual assessment',
});

export const CmsTier = Object.freeze({
  LowComplexityDyad: 'Tier 1: Low Complexity Individual',
  ModerateComplexityDyad: 'Tier 2: Moderate/High Complexity Individual',
  HighComplexityDyad: 'Tier 3: Low Complexity Dyad',
  LowComplexityIndividual: 'Tier 4: Moderate Complexity Dyad',
  ModerateHighComplexityIndividual: 'Tier 5: High Complexity Dyad',
});

export const CmsReferralSource = Object.freeze({
  ReferredByHealthcareProvider: 'Referred by a healthcare provider',
  ReferredByCommunityBasedOrganization: 'Referred by a community-based organization',
  SelfReferral: 'Self-referral',
});

export const ReAssessmentReason = Object.freeze({
  ChangeInSeverityOfPatientDementia:
    "Re-assessment due to change in severity of patient's dementia",
  ChangeInCaregiverStatus: 'Re-assessment due to change in caregiver status',
  ChangeInSeverityAndCaregiverStatus:
    "Re-assessment due to change in both severity of patient's dementia and change in caregiver status",
  ChangeInResidenceType: "Re-assessment due to change in patient's residence type",
  ChangeInCaregiverStatusAndResidenceType:
    "Re-assessment due to change in both caregiver status and change in patient's residence type",
  ChangeInSeverityAndResidenceType:
    "Re-assessment due to change in both severity of patient's dementia and change in patient's residence type",
  ChangeInSeverityAndCaregiverStatusAndResidenceType:
    "Re-assessment due to change in severity of patient's dementia, change in patient's residence type, and change in caregiver status",
});

export const CaregiverStatus = Object.freeze({
  NewPrimaryCaregiver: 'New primary caregiver',
  LossOfCaregiver: 'Loss of caregiver so patient is without a caregiver',
  ChangeInZBIScore: 'Same caregiver but change in ZBI score',
  Other: 'Other (please specify)',
});

export const ClinicianAttestation = Object.freeze({
  YesPatientMeetsGuidelines:
    "Yes, the patient meets the National Institute on Aging-Alzheimer's Association diagnostic guidelines for dementia and/or the DSM-5 diagnostic guidelines for major neurocognitive disorder.",
  YesReceivedWrittenReport: 'Yes, I received a written report of a documented dementia diagnosis.',
  No: 'No, I cannot attest to either statement.',
});

export const NursingHomeStatus = Object.freeze({
  ConfirmedNotNursingHomeResident: 'Confirmed - Not nursing home resident',
  NursingHomeResident: 'Nursing home resident',
});

export const ResidenceType = Object.freeze({
  PrivateResidence: 'Private residence',
  RCCAssistedLivingFacility: 'RCC - Assisted living facility',
  RCCMemoryCareProgram: 'RCC - Memory care program (excludes nursing home level of care)',
  RCCOther: 'RCC - Other',
});

export const UnalignmentReason = Object.freeze({
  BeneficiaryOrTheirLegalRepresentativeRequestedToNoLongerReceiveGUIDEServices:
    'Beneficiary or their legal representative requested to no longer receive GUIDE services',
  BeneficiaryIsInHospice: 'Beneficiary is in hospice',
  BeneficiaryEnrolledInMedicareAdvantage: 'Beneficiary enrolled in Medicare Advantage',
  BeneficiaryEnrolledInPACE: 'Beneficiary enrolled in PACE',
  BeneficiaryNoLongerHasMedicarePartAAndB: 'Beneficiary no longer has Medicare Part A and B',
  BeneficiaryNoLongerHasMedicareAsTheirPrimaryPayer:
    'Beneficiary no longer has Medicare as their primary payer',
  BeneficiaryIsDeceased: 'Beneficiary is deceased',
  BeneficiaryMovedOutsideOfGUIDEZipCode:
    "Beneficiary moved outside of GUIDE Participant's ZIP-code service area",
  BeneficiaryNoLongerHasDementia: 'Beneficiary no longer has dementia which qualifies for GUIDE',
  BeneficiaryIsALongTermNursingHomeResident: 'Beneficiary is a long-term nursing home resident',
  BeneficiaryWasAlignedInError: 'Beneficiary was aligned in error',
});

export const AssessmentTypeOptions = Object.values(AssessmentType).map((type) => ({
  value: type,
  label: type,
}));

export const CmsTierOptions = Object.values(CmsTier).map((tier) => ({
  value: tier,
  label: tier,
}));

export const CmsReferralSourceOptions = Object.values(CmsReferralSource).map((source) => ({
  value: source,
  label: source,
}));

export const ReAssessmentReasonOptions = Object.values(ReAssessmentReason).map((reason) => ({
  value: reason,
  label: reason,
}));

export const CaregiverStatusOptions = Object.values(CaregiverStatus).map((status) => ({
  value: status,
  label: status,
}));

export const ClinicianAttestationOptions = Object.values(ClinicianAttestation).map(
  (attestation) => ({
    value: attestation,
    label: attestation,
  }),
);

export const NursingHomeStatusOptions = Object.values(NursingHomeStatus).map((status) => ({
  value: status,
  label: status,
}));

export const UnalignmentReasonOptions = Object.values(UnalignmentReason).map((reason) => ({
  value: reason,
  label: reason,
}));

export const ResidenceTypeOptions = Object.values(ResidenceType).map((type) => ({
  value: type,
  label: type,
}));
